import { render } from "./AddCompanyContracts.vue?vue&type=template&id=3b2418ed&scoped=true"
import script from "./AddCompanyContracts.vue?vue&type=script&lang=js"
export * from "./AddCompanyContracts.vue?vue&type=script&lang=js"

import "./AddCompanyContracts.vue?vue&type=style&index=0&id=3b2418ed&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2418ed"]])

export default __exports__